import { connect } from "react-redux";
import { Space } from "antd";
import { logoutAction, refreshCsrf } from "../../../redux/actions";
import Logout from "../Logout/Logout";

// const polyuColor = ewcms.polyuRed;
// const dropdownMenuStyle = {
//   fontSize: "0.875rem",
//   justifyContent: "flex-start",
// };
// const dropdownIconStyle = { color: polyuColor, fontSize: "12px" };

// const NO_OF_CHECKING      = 30;
// const CHECK_DURATION_SECS = 60; //seconds
// const NO_OF_CHECKING = 30;

// type MenuProp = {
//   key: string;
//   label: string | JSX.Element;
// };

function HeaderBar(props) {
  const {
    // refreshCsrf,
    // logout,
    // csrf,
    // onSwitchWidth,
    // onSwitchBanner,
    // netId,
    device,
  } = props;

  // const [width, setWidth] = useState("container-best");
  // const [banner, setBanner] = useState("default");

  // let myTimer = useRef<NodeJS.Timeout | null>(null);

  // const selectedIcon = useMemo(
  //   () => <Icon type="CheckCircleTwoTone" twoToneColor="#52c41a" />,
  //   []
  // );
  // const optionIcon = useMemo(
  //   () => <Icon type="MinusCircleTwoTone" twoToneColor="#ff4d4f" />,
  //   []
  // );
  // const dropDownIcon = useMemo(
  //   () => (
  //     <Icon
  //       type="CaretDownOutlined"
  //       style={{ color: polyuColor, fontSize: "8px" }}
  //     />
  //   ),
  //   []
  // );

  // const widthItems: MenuProp[] = useMemo(
  //   () => [
  //     {
  //       label: label("screen.dashboard.headerbar.viewoption.default"),
  //       key: "container",
  //     },
  //     {
  //       label: label("screen.dashboard.headerbar.viewoption.best"),
  //       key: "container-best",
  //     },
  //     {
  //       label: label("screen.dashboard.headerbar.viewoption.full"),
  //       key: "container-ig",
  //     },
  //   ],
  //   []
  // );

  // const bannerItems: MenuProp[] = useMemo(
  //   () => [
  //     {
  //       label: label("screen.dashboard.headerbar.banneroption.simple"),
  //       key: "simple",
  //     },
  //     {
  //       label: label("screen.dashboard.headerbar.banneroption.default"),
  //       key: "default",
  //     },
  //   ],
  //   []
  // );

  // const setItems = useCallback(
  //   (itemCode: string) => {
  //     let result: MenuProp[] = [];
  //     let key = "";
  //     let itemArr: MenuProp[] = [];
  //     switch (itemCode) {
  //       case "width":
  //         key = width;
  //         itemArr = widthItems;
  //         break;
  //       case "banner":
  //         key = banner;
  //         itemArr = bannerItems;
  //         break;
  //       default:
  //         break;
  //     }
  //     if (!_.isEmpty(key)) {
  //       for (const item of itemArr) {
  //         result.push({
  //           ...item,
  //           label: (
  //             <span className="cust-vertical-center" style={dropdownMenuStyle}>
  //               {item.key === key ? selectedIcon : optionIcon} &nbsp;{" "}
  //               {item.label}
  //             </span>
  //           ),
  //         });
  //       }
  //     } else {
  //       for (const item of itemArr) {
  //         result.push({
  //           ...item,
  //           label: <span style={dropdownMenuStyle}>{item.label}</span>,
  //         });
  //       }
  //     }

  //     return result;
  //   },
  //   [width, banner, widthItems, bannerItems, optionIcon, selectedIcon]
  // );

  // const [wid, setWid] = useState([] as MenuProp[]);
  // const [ban, setBan] = useState([] as MenuProp[]);

  // useEffect(() => {
  //   setWid(setItems("width"));
  // }, [width, setItems]);
  // useEffect(() => {
  //   setBan(setItems("banner"));
  // }, [banner, setItems]);

  // let ewcmsItems = [
  //   { key: "hb_sm_swm", label: "View", children: wid },
  //   { key: "hb_sm_sbm", label: "Banner", children: ban },
  // ];

  // let logoutItems = [
  //   {
  //     key: "logout",
  //     label: (
  //       <span className="cust-vertical-center" style={dropdownMenuStyle}>
  //         <Icon type="LogoutOutlined" style={dropdownIconStyle} />
  //         &nbsp;{label("LB0010")}
  //       </span>
  //     ),
  //   },
  // ];

  // const onLogoutClick = (e) => {
  //   if (e.key === "logout" && myTimer.current) {
  //     clearTimeout(myTimer.current);
  //     logout(csrf);
  //   }
  // };

  // const onMenuClick = (e) => {
  //   setBanner(e.key);
  //   onSwitchBanner(e, e.key);

  //   switch(e.keyPath[1]){
  //     case "hb_sm_swm":
  //       setWidth(e.key);
  //       onSwitchWidth(e, e.key);
  //     break;
  //     case "hb_sm_sbm":
  //       setBanner(e.key);
  //       onSwitchBanner(e, e.key);
  //       break;
  //     default:
  //       break;
  //   }
  // };

  // const timeOutFunction = useCallback(
  //   (index) => {
  //     myTimer.current = setTimeout(() => {
  //       if (index > 0) {
  //         timeOutFunction(index - 1);
  //         refreshCsrf();
  //       }
  //     }, CHECK_DURATION_SECS * 1000);
  //   },
  //   [myTimer, refreshCsrf]
  // );

  // useEffect(() => {
  //   timeOutFunction(NO_OF_CHECKING);
  // }, [timeOutFunction]);
  return device.size === "desktop" ? (
    <></>
  ) : (
    <Space size="large" key="headerBar">
      {/* <Dropdown
        menu={{
          items: ban,
          onClick: onMenuClick,
          triggerSubMenuAction: device.size === "desktop" ? "hover" : "click",
        }}
        trigger={device.size === "desktop" ? ["hover"] : ["click"]}
        key="hb_dd_swm"
      >
        {
          <span
            className="cust-vertical-center selectCurosr"
            style={{ display: "flex" }}
          >
            <Icon type="SettingOutlined" style={dropdownIconStyle} />
            &nbsp;Banner &nbsp;{dropDownIcon}
          </span>
        }
      </Dropdown> */}
      <Logout />
    </Space>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.session.lang,
    csrf: state.action.csrf,
    netId: state.session.netId,
    portalClient: state.portalClient,
    currPath: state.dashboard.routeTo,
    device: state.session.device,
  };
};

const mapDispatchToProps = (dispatch) => ({
  logout: (csrf) => {
    dispatch(logoutAction(csrf));
  },
  refreshCsrf: () => {
    dispatch(refreshCsrf());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderBar);
